$(document).ready(function() {
  var paddleConfig = $("#paddle-config");
  let paddleCheckoutState;
  let paddleCheckoutPrices;
  if (paddleConfig.length > 0) {
    if (typeof window.Paddle == "object") {
      var config = paddleConfig.data("config");
      //Paddle.Environment.set('sandbox');
      Paddle.Setup({
        vendor: config.vendor
      });
      window.paddleCallback = function paddleCallback(data) {
        if (data.event === "Checkout.Complete") {
          location.href = "/checkouts/complete?p_id=" + data.checkoutData.product;
        }
        var eventField = document.getElementById("paddle-checkout-event");
        eventField.innerHTML = data.event;
        window.paddleCheckoutState = data.event;
        window.paddleCheckoutPrices = data.eventData.checkout.prices;
        eventField.dispatchEvent(new Event("change"));
      };
    }
  }
});
